/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Grid, Typography, withStyles, Hidden } from '@material-ui/core';
import SectionHeader from '../../components/SectionHeader';
import Asset from '../../components/Asset';

const styles = theme => ({
  about: {
    backgroundColor: theme.palette.common.white
  },
  img: {
    paddingRight: '100px'
  },
  heroWrapper: {
    padding: '0 100px 50px',
    background: 'url(/images/assets/asset-60.png) 10% 90% no-repeat',
    backgroundSize: '52px 135px',
    [theme.breakpoints.down('sm')]: {
      padding: '40px 0',

      backgroundSize: '26px 77px',
      backgroundPosition: '0 100%'
    }
  },
  heroText: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '30px'
    }
  }
});

const About = class extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <section className={classes.about}>
        <div className="wrapper">
          <Grid
            container
            direction="column"
            justify="center"
            style={{ minHeight: '60vh' }}
          >
            <Grid item>
              <SectionHeader
                color="primary"
                text="about"
                subtitle='aka "Your backstage pass to the software dev sh*tshow"'
                subcolor="secondary"
                img={36}
                imgHeight={40}
              />
            </Grid>
            <Grid item>
              <Grid container spacing={24} alignItems="center">
                <Grid item sm xs={12}>
                  <Typography paragraph variant="body1" align="center">
                    If you are here then you already <strong>KNOW</strong>.
                  </Typography>
                  <Typography paragraph variant="body1" align="center">
                    Somebody told you how awesome it is and you could not
                    believe it. <Asset img={32} />
                  </Typography>
                  <Typography paragraph variant="body1" align="center">
                    Or you've played it and your mind was blown.
                  </Typography>
                  <Typography paragraph variant="body1" align="center">
                    One way or another you <strong>KNOW</strong>{' '}
                    <Asset img={17} />
                  </Typography>
                  <div className={classes.heroWrapper}>
                    <Typography
                      align="center"
                      variant="h4"
                      color="secondary"
                      className={classes.heroText}
                    >
                      WE'VE MADE THE WORLD’S MOST INACCURATE
                      <br />
                      WEB DEVELOPMENT SHOP SIMULATOR
                      <br />
                      IN THE FORM OF A CARD GAME
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Grid>

            <Grid item>
              <Grid container spacing={24} alignItems="center">
                <Hidden mdUp>
                  <Grid item xs={12} md={4}>
                    <div style={{ textAlign: 'center' }}>
                      <img
                        src="/images/assets/asset-50.png"
                        alt="About section"
                      />
                    </div>
                  </Grid>
                </Hidden>
                <Grid item sm xs={12}>
                  <Typography paragraph variant="body1">
                    What you might not know is how we managed to do it. It's
                    surprisingly simple really. <Asset img={1} />
                    <br /> A group of people at u2i decided that in the face of
                    global climate change, growing wealth gap and raising waves
                    of populism what the world really needs is a card game about
                    the IT market. But instead of quitting our day job (and
                    getting it done in a month <Asset img={31} />) we decided to
                    spend our self-dev time (the 10% of our work time our
                    company graciously offers us to do our own stuff) to
                    bringing our dream to life...
                  </Typography>
                </Grid>
                <Hidden smDown>
                  <Grid item xs={12} md={4}>
                    <div style={{ textAlign: 'center' }}>
                      <img
                        src="/images/assets/asset-50.png"
                        alt="About section"
                      />
                    </div>
                  </Grid>
                </Hidden>
              </Grid>
            </Grid>
            <Grid item>
              <Grid container spacing={24} alignItems="center">
                <Grid item xs={12} md={4}>
                  <div style={{ textAlign: 'center' }}>
                    <img
                      src="/images/assets/asset-61.png"
                      alt="About section"
                    />
                  </div>
                </Grid>
                <Grid item sm xs={12}>
                  <Typography paragraph variant="body1">
                    Two years later, after defeating many obstacles (mostly
                    laziness, self-doubt <Asset img={34} /> and creative block)
                    we are proud to release the Beta version of our game.{' '}
                    <strong>Fun</strong> was always at the core of what we set
                    off to do. We had tons of <strong>fun</strong> building it.
                    Tons of <strong>fun</strong> playtesting it. And now we hope
                    you'll have even more <strong>fun</strong> beta-testing it
                    for us. <Asset img={14} />
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </section>
    );
  }
};

export default withStyles(styles)(About);
